import { z } from 'zod';
import { dateValidation, coerceNumber } from '../../validation';

export const EbpCaseAppointmentsSchema = z.object({
  // completed by expert (nurse) or professional
  completed: coerceNumber(z.number()),
  completedByProfessionals: coerceNumber(z.number()),
  completedByExperts: coerceNumber(z.number()),
  latestCompletedByExpertDate: dateValidation().nullish(),
});

export type EbpCaseAppointments = z.infer<typeof EbpCaseAppointmentsSchema>;
